import { boolean, defineAction, enumerated, number, object, string } from '~/prix'
import llmChatMessageCreateAction from './llmChatMessageCreate.action.json' with { type: 'json' }

const llmChatMessageCreateDefinition = defineAction({
  ...llmChatMessageCreateAction,

  input: object({
    chatId: number(),
    message: object({
      id: string(),
      createdAt: string(),
      role: enumerated({
        user: 'user',
        assistant: 'assistant',
        system: 'system',
        data: 'data',
      }),
      content: string(),
    }),
  }),
  output: object({
    // Para streaming, a resposta real vai pelo stream
    success: boolean().isOptional(),
  }),
})

export default llmChatMessageCreateDefinition
